import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/store/authStore';
import { PATHS } from '@/constants/path';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={PATHS.LOGIN}
        replace
      />
    );
  }
  return children;
}
